var _title, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGoogleCalendar = function SvgGoogleCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "google-calendar")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "google-calendar"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(9, 9)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "35.1052632 10.8947368 24.2105263 9.68421053 10.8947368 10.8947368 9.68421053 23 10.8947368 35.1052632 23 36.6184211 35.1052632 35.1052632 36.3157895 22.6973684"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8604772,29.6762947 C14.9556491,29.0650596 14.3292421,28.1723368 13.9872281,26.991993 L16.0875719,26.1265474 C16.2781895,26.8528632 16.6110035,27.4156772 17.0861754,27.8151509 C17.5582807,28.2146246 18.1333614,28.4113754 18.8051228,28.4113754 C19.4920561,28.4113754 20.0823088,28.2025193 20.5755579,27.7849684 C21.068807,27.3672561 21.3170456,26.8346246 21.3170456,26.1899789 C21.3170456,25.5303228 21.0567018,24.9915579 20.5361754,24.574007 C20.0156491,24.1562947 19.3619649,23.9476 18.5812561,23.9476 L17.3676632,23.9476 L17.3676632,21.8684 L18.4571368,21.8684 C19.1288982,21.8684 19.6949404,21.6868211 20.1549404,21.3236632 C20.6149404,20.9605053 20.8449404,20.4641895 20.8449404,19.8318105 C20.8449404,19.2688351 20.6391509,18.8209404 20.2275719,18.4850596 C19.815993,18.1491789 19.2954667,17.9797053 18.6629263,17.9797053 C18.0455579,17.9797053 17.555214,18.1430456 17.1920561,18.4729544 C16.8288982,18.8028632 16.5656491,19.2083088 16.3992421,19.6865474 L14.3202035,18.8209404 C14.5955579,18.0402316 15.1009123,17.3502316 15.8424,16.754007 C16.5838877,16.1577825 17.5310035,15.8582175 18.6810035,15.8582175 C19.5314386,15.8582175 20.2971368,16.0215579 20.9750316,16.3514667 C21.6529263,16.6813754 22.1855579,17.1383088 22.5698596,17.7193614 C22.9541614,18.3034807 23.1449404,18.9571649 23.1449404,19.6834807 C23.1449404,20.4249684 22.9662667,21.0513754 22.6092421,21.5657684 C22.2520561,22.0803228 21.8133614,22.4736632 21.2928351,22.7491789 L21.2928351,22.8731368 C21.9797684,23.1607579 22.5396772,23.5994526 22.9814386,24.1897053 C23.4202947,24.7797965 23.6412561,25.4849684 23.6412561,26.3081263 C23.6412561,27.1312842 23.4324,27.8666386 23.0146877,28.5112842 C22.5971368,29.1557684 22.0191509,29.6641895 21.2867018,30.0334807 C20.5513474,30.4026105 19.7251228,30.5903457 18.8081895,30.5903457 C17.745993,30.5933895 16.7654667,30.2876912 15.8604772,29.6762947 Z",
    id: "Path",
    fill: "#2684FC"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#2684FC",
    points: "28.7498386 19.2533404 26.4558105 20.9208 25.3029053 19.1715088 29.4398386 16.1876421 31.0256281 16.1876421 31.0256281 30.2629965 28.7498386 30.2629965"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#E94235",
    points: "35.1052632 46 46 35.1052632 46 32.6842105 35.1052632 32.6842105 35.1052632 35.1052632 32.6842105 35.1052632 32.6842105 46"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#00AC47",
    points: "35.1052632 35.1052632 8.47368421 35.1052632 8.47368421 46 35.1052632 46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.63157895,0 C1.62512351,0 0,1.62512351 0,3.63157895 L0,37.5263158 L10.8947368,37.5263158 L10.8947368,10.8947368 L37.5263158,10.8947368 L37.5263158,0 L3.63157895,0 Z",
    id: "Path",
    fill: "#2684FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,35.1052632 L0,42.3684211 C0,44.3748281 1.62512351,46 3.63157895,46 L10.8947368,46 L10.8947368,35.1052632 L0,35.1052632 Z",
    id: "Path",
    fill: "#00832D"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFBA00",
    points: "46 8.47368421 35.1052632 8.47368421 35.1052632 35.1052632 46 35.1052632"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,10.8947368 L46,3.63157895 C46,1.62512351 44.3748281,0 42.3684211,0 L35.1052632,0 L35.1052632,10.8947368 L46,10.8947368 Z",
    id: "Path",
    fill: "#0066DA"
  }))))));
};
export default SvgGoogleCalendar;